import React, { useState } from 'react';

import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
// import FilterButton from '../components/DropdownFilter';
// import Datepicker from '../components/Datepicker';
// import DashboardCard10 from '../partials/dashboard/DashboardCard10';
import DashboardCard17 from '../../partials/dashboard/DashboardCard17';
import Dashboardcard19 from '../../partials/dashboard/DashboardCard19';
import DashboardCard19grup from '../../partials/dashboard/DashboardCard19grup';
import Banner from '../../partials/Banner';
import { useNavigate } from "react-router-dom";


function Institutionsgroup() {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const handleNewRows = (item) => {
        //////////////////////////////console.log(item);
    
       navigate("/createuser");
      };

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="w-full grid grid-cols-12 gap-4 justify-center">   
                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full">
                                <DashboardCard19grup />
                            </div>

                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xs:pb-10 xl:col-span-6 w-full xs:pb-10">
                                <Dashboardcard19 />
                            </div>
                        </div>

                    </div>
                </main>

                <Banner />

            </div>
        </div>
    );
}

export default Institutionsgroup;